/**
 * Écart réel vs attendu pour les métriques de performance.
 * - Cible absente (null / vide) : métrique non comparée.
 * - Cible à 0 % : comparaison explicite (0 % atteint, dépassement, ou manque à gagner).
 */
export function getPerformanceDeviation(expected, actual) {
  if (expected === null || expected === undefined || expected === "") {
    return null;
  }

  const exp = Number(expected);
  if (!Number.isFinite(exp)) {
    return null;
  }

  if (actual === null || actual === undefined) {
    return -100;
  }

  const act = Number(actual);
  if (!Number.isFinite(act)) {
    return null;
  }

  if (exp === 0) {
    if (act === 0) return 0;
    if (act > 0) return 100;
    return -100;
  }

  return ((act - exp) / exp) * 100;
}

export function parseConfiguredExpected(raw) {
  if (raw === null || raw === undefined || raw === "") {
    return null;
  }
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
}
